enum LeaderboardVisibilitySettingValue {
  OWNER = "owner",
  OWNER_MANAGER = "owner-manager",
  PUBLIC = "public",
}

export default LeaderboardVisibilitySettingValue;
